const getters = {
    store_id: (state) => {
        return state.store_id
    },
    pred_date: (state) => {
        return state.pred_date ? state.pred_date : []
    },
    graph_setting: (state) => {
        return state.graph_setting
    }
};

export default getters;